import React, { useState, useEffect } from 'react';
import EventoService from '../services/eventoService';
import '../style/components/CrearEventoModal.css';

const formatLocalFecha = (fechaInput) => {
    if (!fechaInput) return '';
    if (typeof fechaInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fechaInput)) {
        return fechaInput;
    }
    const d = new Date(fechaInput);
    if (Number.isNaN(d.getTime())) return '';
    return new Date(d.getTime() - (d.getTimezoneOffset() * 60000)).toISOString().split('T')[0];
};

const CrearEventoModal = ({ isOpen, onClose, onSave, selectedDate, idTramite }) => {
    const [tiposEvento, setTiposEvento] = useState([]);

    // Estado para controlar qué tiempos están seleccionados
    const [tiemposSeleccionados, setTiemposSeleccionados] = useState({
        "0": false,  // Al momento del evento (0 horas antes)
        "1": true,   // 1 hora antes
        "5": false,  // 5 horas antes
        "24": true   // 24 horas antes
    });

    const [evento, setEvento] = useState({
        titulo: '',
        descripcion: '',
        fecha: '',
        horaInicio: '',
        horaFin: '',
        todoElDia: false,
        tipoEvento: '',
        idTramite: idTramite || '',
        visibilidad: idTramite ? 'POR_AREA' : 'PUBLICO',
        canalesNotificacion: {
            whatsapp: false,
            email: false,
            inapp: true
        },
        tiemposRecordatorio: []
    });

    useEffect(() => {
        if (isOpen) {
            EventoService.getTiposEvento()
                .then(response => {
                    setTiposEvento(response.data);
                    setEvento({
                        titulo: '',
                        descripcion: '',
                        fecha: formatLocalFecha(selectedDate),
                        horaInicio: '',
                        horaFin: '',
                        todoElDia: false,
                        tipoEvento: response.data.length > 0 ? response.data[0].nombre : '',
                        idTramite: idTramite || '',
                        visibilidad: idTramite ? 'POR_AREA' : 'PUBLICO',
                        canalesNotificacion: {
                            whatsapp: false,
                            email: false,
                            inapp: true
                        },
                        tiemposRecordatorio: []
                    });
                    // Resetear tiempos por defecto al abrir
                    setTiemposSeleccionados({ "0": false, "1": true, "5": false, "24": true });
                })
                .catch(error => console.error("Error al cargar tipos de evento:", error));
        }
    }, [isOpen, selectedDate, idTramite]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setEvento(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value
        }));
    };

    // Manejador para los checkboxes de tiempo
    const handleTiempoChange = (horas) => {
        setTiemposSeleccionados(prev => ({
            ...prev,
            [horas]: !prev[horas]
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Procesar tiempos (convertir el objeto de estado a array de numeros)
        const tiemposArray = Object.keys(tiemposSeleccionados)
            .filter(key => tiemposSeleccionados[key]) // Solo los true
            .map(key => parseInt(key)); // Convertir "24" a 24

        const eventoParaEnviar = {
            ...evento,
            fecha: formatLocalFecha(evento.fecha),
            visibilidad: evento.visibilidad || (evento.idTramite ? 'POR_AREA' : 'PUBLICO'),
            canalesNotificacion: ['inapp'],
            tiemposRecordatorio: tiemposArray
        };

        console.log('📤 Enviando evento (visibilidad=', evento.visibilidad, '):', eventoParaEnviar);
        onSave(eventoParaEnviar);
    };

    return (
        <div className="modal-overlay" style={{overflowY: "auto"}}>
            <div className="evento-modal-content" style={{
                borderRadius: "16px",
                border: "none",
                maxWidth: "600px",
                boxShadow: "var(--shadow-lg)",
                maxHeight: "90vh",
                overflowY: "auto",
                margin: "2rem auto"
            }}>
                {/* Header Moderno con Gradiente Verde */}
                <div style={{
                    background: "var(--gradient-success)",
                    padding: "1.5rem 2rem",
                    color: "white",
                    position: "relative"
                }}>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center gap-3">
                            <i className="bi bi-calendar-plus" style={{fontSize: "2rem"}}></i>
                            <h2 className="mb-0 fw-bold" style={{fontSize: "1.5rem", color: "white"}}>Crear Nuevo Evento</h2>
                        </div>
                        <button
                            type="button"
                            onClick={onClose}
                            style={{
                                background: "rgba(255,255,255,0.2)",
                                borderRadius: "8px",
                                padding: "0.5rem",
                                border: "none",
                                color: "white",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "36px",
                                height: "36px",
                                transition: "all 0.2s ease"
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.3)"}
                            onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.2)"}
                        >
                            <i className="bi bi-x-lg" style={{fontSize: "1.25rem"}}></i>
                        </button>
                    </div>
                </div>

                {/* Formulario */}
                <form onSubmit={handleSubmit} style={{padding: "2rem"}}>
                    <div className="form-group">
                        <label>Título</label>
                        <input type="text" name="titulo" value={evento.titulo} onChange={handleChange} required />
                    </div>
                    <div className="form-group">
                        <label>Tipo de Evento</label>
                        <select name="tipoEvento" value={evento.tipoEvento} onChange={handleChange} required>
                            {tiposEvento.map(tipo => (
                                <option key={tipo.id} value={tipo.nombre}>{tipo.nombre}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>Visibilidad</label>
                        <div className="d-flex gap-3 flex-wrap align-items-center">
                            <label className="d-flex align-items-center gap-2 cursor-pointer mb-0">
                                <input
                                    type="radio"
                                    name="visibilidad"
                                    value="PUBLICO"
                                    checked={evento.visibilidad === 'PUBLICO'}
                                    onChange={(e) => setEvento(prev => ({ ...prev, visibilidad: e.target.value }))}
                                />
                                <span>Público</span>
                            </label>
                            <label className="d-flex align-items-center gap-2 cursor-pointer mb-0">
                                <input
                                    type="radio"
                                    name="visibilidad"
                                    value="PRIVADO"
                                    checked={evento.visibilidad === 'PRIVADO'}
                                    onChange={(e) => setEvento(prev => ({ ...prev, visibilidad: e.target.value }))}
                                />
                                <span>Privado</span>
                            </label>
                            <label className="d-flex align-items-center gap-2 cursor-pointer mb-0">
                                <input
                                    type="radio"
                                    name="visibilidad"
                                    value="POR_AREA"
                                    checked={evento.visibilidad === 'POR_AREA'}
                                    onChange={(e) => setEvento(prev => ({ ...prev, visibilidad: e.target.value }))}
                                />
                                <span>Por Área</span>
                            </label>
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Fecha</label>
                        <input type="date" name="fecha" value={evento.fecha} onChange={handleChange} required />
                    </div>
                    <div className="form-group-inline">
                        <div className="form-group">
                            <label>Hora Inicio</label>
                            <input type="time" name="horaInicio" value={evento.horaInicio} onChange={handleChange} disabled={evento.todoElDia} />
                        </div>
                        <div className="form-group">
                            <label>Hora Fin</label>
                            <input type="time" name="horaFin" value={evento.horaFin} onChange={handleChange} disabled={evento.todoElDia} />
                        </div>
                    </div>
                    <div className="form-group-checkbox">
                        <input type="checkbox" id="todoElDia" name="todoElDia" checked={evento.todoElDia} onChange={handleChange} />
                        <label htmlFor="todoElDia">Todo el día</label>
                    </div>
                    <div className="form-group">
                        <label>Descripción</label>
                        <textarea name="descripcion" value={evento.descripcion} onChange={handleChange}></textarea>
                    </div>

                    {/* --- SECCION DE CONFIGURACION DE NOTIFICACIONES --- */}
                    <div className="notification-settings-container" style={{ border: '1px solid #e0e0e0', padding: '15px', borderRadius: '8px', marginTop: '10px', backgroundColor: '#f9f9f9' }}>
                        <h4 style={{ marginTop: 0, color: '#0d6efd', fontSize: '1rem' }}>🔔 Configuración de Alertas</h4>

                        {/* Tiempos */}
                        <div className="form-group">
                            <label className="section-label fw-bold" style={{fontSize: '0.9rem'}}>¿Cuando avisar?:</label>
                            <div className="tiempos-notificacion d-flex flex-wrap gap-3">
                                <div className="form-group-checkbox me-3">
                                    <input
                                        type="checkbox"
                                        id="tiempo0"
                                        checked={tiemposSeleccionados["0"]}
                                        onChange={() => handleTiempoChange("0")}
                                    />
                                    <label htmlFor="tiempo0" >En el momento</label>
                                </div>
                                <div className="form-group-checkbox me-3">
                                    <input
                                        type="checkbox"
                                        id="tiempo1"
                                        checked={tiemposSeleccionados["1"]}
                                        onChange={() => handleTiempoChange("1")}
                                    />
                                    <label htmlFor="tiempo1">1 hora antes</label>
                                </div>
                                <div className="form-group-checkbox me-3">
                                    <input
                                        type="checkbox"
                                        id="tiempo5"
                                        checked={tiemposSeleccionados["5"]}
                                        onChange={() => handleTiempoChange("5")}
                                    />
                                    <label htmlFor="tiempo5">5 horas antes</label>
                                </div>
                                <div className="form-group-checkbox">
                                    <input
                                        type="checkbox"
                                        id="tiempo24"
                                        checked={tiemposSeleccionados["24"]}
                                        onChange={() => handleTiempoChange("24")}
                                    />
                                    <label htmlFor="tiempo24">1 día antes (24h)</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-actions mt-4 d-flex justify-content-end gap-2">
                        <button 
                            type="button" 
                            onClick={onClose}
                            style={{
                                background: "white",
                                color: "#6b7280",
                                border: "2px solid #e5e7eb",
                                borderRadius: "10px",
                                padding: "0.625rem 1.5rem",
                                fontWeight: 500,
                                cursor: "pointer",
                                transition: "all 0.2s"
                            }}
                        >
                            Cancelar
                        </button>
                        <button 
                            type="submit"
                            style={{
                                background: "var(--gradient-success)",
                                color: "white",
                                border: "none",
                                borderRadius: "10px",
                                padding: "0.625rem 1.5rem",
                                fontWeight: 600,
                                boxShadow: "var(--shadow-md)",
                                cursor: "pointer",
                                transition: "all 0.2s"
                            }}
                        >
                            <i className="bi bi-check-circle me-2"></i>
                            Guardar Evento
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default CrearEventoModal;